import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AchievementDefinitionDto, UpdateAchievementDefinitionDto } from "../../../models/achievement/dto/achievement.dto";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_ACHIEVEMENTS_QUERY_KEY } from "./useListAchievements";

export const useUpdateAchievement = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: ({ achievementId, ...input }: { achievementId: string } & UpdateAchievementDefinitionDto) => {
            if (!selectedOrganization?.id) throw new Error('No organization selected');
            return client.fetchApi<AchievementDefinitionDto, UpdateAchievementDefinitionDto>({
                endpoint: `achievements/admin/${selectedOrganization.id}/${achievementId}`,
                method: 'PUT',
                body: input,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_ACHIEVEMENTS_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
